// const BaseUrl = "http://localhost:8080";
// const BaseUrl = "https://aiipb.hkcl.net";
const BaseUrl = "https://mentza.hkcl.in";

export default BaseUrl;